import { UserRoles } from '../../constants'
import { SENSE_ORGANIZATION_ID } from '../../constants/UserRoles'

const userSelectors = {
    id: state => state.auth.user?.id,
    user: state => state.auth.user,
    isWaitingForGetCurrentUser: state => state.auth.isWaitingForGetCurrentUser,
    isSenseUser: state => state.auth.user?.organization_id === SENSE_ORGANIZATION_ID,
    isGatechUser: state => state.auth.user?.email.endsWith('@gatech.edu'),
    isAdmin: state => state.auth.user?.roles.includes(UserRoles.ADMIN),
    isShopUser: state => state.auth.user?.roles.includes(UserRoles.SHOP_USER),
    isLmsConfigurator: state => state.auth.user?.roles.includes(UserRoles.LMS_CONFIGURATOR),
    isBetaTester: state => state.auth.user?.roles.includes(UserRoles.BETA_TESTER),
    isReportViewer: state => state.auth.user?.roles.includes(UserRoles.REPORT_VIEWER),
    isImpersonator: state => state.auth.user?.roles.includes(UserRoles.IMPERSONATOR),
    isUserManager: state => state.auth.user?.roles.includes(UserRoles.USER_MANAGER),
    isSystemAdmin: state =>
        state.auth.user?.roles.includes(UserRoles.SYSTEM_ADMIN) &&
        state.auth.user?.organization_id === SENSE_ORGANIZATION_ID,
    isCLLibrarian: state => state.auth.user?.roles.includes(UserRoles.CL_LIBRARIAN),
    email: state => state.auth.user?.email,
    name: state => state.auth.user?.name,
    organizationId: state => state.auth.user?.organization_id,
    thresholds: state => ({
        low: state.auth.user?.low_threshold,
        medium: state.auth.user?.high_threshold,
        high: state.auth.user?.very_high_threshold,
    }),
    editingUserId: state => state.user.editingUserId,
    showInviteUserDrawer: state => state.user.showInviteUserDrawer,
}

export default userSelectors
